import { IsUUID, IsNotEmpty } from 'class-validator';

export class GetVacaitionsCompaniesListDto {
  @IsUUID()
  @IsNotEmpty()
  company_id: string;
}
